define(function (require, exports, module) {
    require('toolkit');

    const app = require('Cloud/Application/app');

    const IS_PHONE = app.getParam('PHONE_BROWSER');
    const IS_PUBLIC = app.getParam('PUBLIC');
    const IS_NEW_SSR = app.getParam('IS_NEW_SSR');
    const IS_PUBLIC_FOLDER_PHONE = app.getParam('PUBLIC_FOLDER') && IS_PUBLIC && IS_PHONE;

    require('Cloud/ui/Loader');

    const modules = [
        'HttpError',
        'NavMenu',
        'Welcome',
        'Datalist',
        'BreadCrumbs',
        'ReactTooltip',
        'Toolbar',
        'Header',
        'Space',
        'Loader',
        'PublicHeight',
        'PublicFile',
        'MobileShare',
        'TopWormBanner',
        'Login',
    ];

    function initModules() {
        modules.forEach((klass) => {
            const name = klass.toLowerCase();

            if (IS_PUBLIC_FOLDER_PHONE && ['space', 'navmenu', 'datalist'].includes(name)) {
                return;
            }

            if (IS_NEW_SSR && name === 'publicheight') {
                return;
            }

            const module = require(`Cloud/ui/${klass}`);

            if (typeof module === 'function') {
                app.ui[name] = module(app);
            } else if (typeof module.default === 'function') {
                app.ui[name] = module.default(app);
            }

            app.emit(`ui:init:${name}`, app.ui[name]);
        });
    }

    module.exports = initModules;
});
